<div class="social-buttons btn-group btn-group"><a class="btn-{{site.name}}" *ngFor="let site of sites" [href]="getLink(site)" target="_blank"><i class="fa fa-{{site.name}}"></i></a></div>


// WEBPACK FOOTER //
// ./src/app/views/social-buttons.pug